// Copied from https://github.schibsted.io/finn/search-quest-front/blob/master/src/lib/useInscreenObserver.ts
import InscreenObserver from '@finn-no/inscreen-observer';
import { MutableRefObject, useEffect } from 'react';

type InscreenObserverOptions = {
    once?: boolean;
    proximity?: number;
    threshold?: number;
    timeout?: number;
};

const DEFAULT_OPTIONS: InscreenObserverOptions = {
    threshold: 0.75,
    timeout: 1000,
    once: true,
};

const useInscreenObserver = (
    ref: MutableRefObject<Element | null>,
    callbackFn: () => void,
    options: InscreenObserverOptions = DEFAULT_OPTIONS,
) => {
    useEffect(() => {
        if (!ref.current) {
            // if the node isn't set then we do nothing, the console.error should show up in
            // TrackJS if for some reason this slips up in production
            console.error('Failed to track inscreen as ref.current is not a node', {
                ref,
            });
            return;
        }

        const observer = new InscreenObserver(callbackFn, options);
        observer.observe(ref.current);

        return () => observer.disconnect();
    }, [ref]);
};

export default useInscreenObserver;
